<template>
  <div
    :class="{ required: data.required }"
    class="field">
    <label>{{ $t(data.label) }}</label>
    <div class="inline fields">
      <div
        v-for="radioButton in data.options"
        :key="radioButton.value"
        :class="{ disabled: radioButton.hasOwnProperty('disabled') && radioButton.disabled }"
        class="field">
        <div class="ui radio checkbox">
          <input
            v-model="input"
            type="radio"
            :name="data.hasOwnProperty('name') ? data.name : `radio-input-${_uid}`"
            :value="radioButton.value">
          <label>{{ $t(radioButton.label) }}</label>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: 'RadioGroupInput',
  props: {
    data: {
      type: Object,
      required: true
    },
    value: {
      validator: (value) => {
        return (value === null || ['string', 'number', 'undefined'].includes(typeof value))
      },
      required: true
    }
  },
  data () {
    return {
      input: this.value
    }
  },
  computed: {
  },
  mounted () {
    if (this.data.hasOwnProperty('default')) {
      this.input = this.data.default
    }
  },
  watch: {
    input (value) {
      this.input = value
      this.$emit('input', this.input)
    }
  }
}
</script>

<style scoped>

</style>
